// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"styles_cardHeader__7_Rpv","card":"styles_card__csnQK","infoIcon":"styles_infoIcon__iP94H"};